import styled from 'styled-components';

import { Button } from '../../../components/Button';
import { PricingSection } from '../../invoices/components/PricingSection';
import { LocationsOptions } from '../pages/activate';
import { useEffect } from 'react';

type ChooseSubscriptionProps = {
  email: string;
  iccid: string;
  reservationId?: string;
  location: LocationsOptions;
  onGoBack?: () => void;
  onMissingInfo: () => void;
};

export const ChooseSubscription = ({
  email,
  iccid,
  reservationId,
  onGoBack,
  location,
  onMissingInfo
}: ChooseSubscriptionProps) => {
  useEffect(() => {
    if (!email || !iccid) {
      onMissingInfo();
    }
  }, [email, iccid]);
  return (
    <Container>
      <PricingSection
        email={email}
        iccid={iccid}
        reservationId={reservationId}
        location={location}
      />
      {onGoBack && (
        <Button onClick={onGoBack} style={{ marginTop: '1rem' }}>
          Back
        </Button>
      )}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
